import mod from "-!./update-image.js?vue&type=script&lang=js&"; export default mod; export * from "-!./update-image.js?vue&type=script&lang=js&"